<template>
  <div class="landing-page-wrapper">
    <div class="landingpage-bg">
      <img class="img-landingpage-bg" src="../../../assets/img/landingpage-bg.png" alt="" />
    </div>
    <div class="landing-top-container">
      <div class="landing-logo">
        <img src="../../../assets/img/isupplier-logo.png" class="img-landing-logo" alt="" />
      </div>
      <div class="landing-logo">
        <img src="../../../assets/img/logo-smm.png" class="img-landing-smm-logo" alt="" />
      </div>
    </div>
    <div class="landing-container">
      <div class="landing-right">
        <div class="step-indicator">
          <div class="step-wrapper">
            <div :class="$store.state.kplhStore.activeLanding == 'register'
              ? 'step-number-white'
              : 'step-number-red'
              " @click="jumpTo('register')">
              1
            </div>
            <div class="step-hr-start"></div>
            <div class="step-name">Registrasi</div>
          </div>
          <div class="step-wrapper">
            <div @click="jumpTo('profile')" :class="$store.state.kplhStore.activeLanding == 'profile'
              ? 'step-number-white'
              : 'step-number-red'
              ">
              2
            </div>
            <div class="step-hr-mid"></div>
            <div class="step-name">Profil</div>
          </div>
          <div class="step-wrapper">
            <div @click="jumpTo('grupah')" :class="$store.state.kplhStore.activeLanding == 'grupah'
              ? 'step-number-white'
              : 'step-number-red'
              ">
              3
            </div>
            <div class="step-hr-mid"></div>
            <div class="step-name">Grup A - H</div>
          </div>
          <div class="step-wrapper">
            <div @click="jumpTo('grupi1')" :class="$store.state.kplhStore.activeLanding == 'grupi1'
              ? 'step-number-white'
              : 'step-number-red'
              ">
              4
            </div>
            <div class="step-hr-mid"></div>
            <div class="step-name">Grup I - 1</div>
          </div>
          <div class="step-wrapper">
            <div @click="jumpTo('grupi2')" :class="$store.state.kplhStore.activeLanding == 'grupi2'
              ? 'step-number-white'
              : 'step-number-red'
              ">
              5
            </div>
            <div class="step-hr-mid"></div>
            <div class="step-name">Grup I - 2</div>
          </div>
          <div class="step-wrapper">
            <div @click="jumpTo('grupjm')" :class="$store.state.kplhStore.activeLanding == 'grupjm'
              ? 'step-number-white'
              : 'step-number-red'
              ">
              6
            </div>
            <div class="step-hr-mid"></div>
            <div class="step-name">Grup J - M</div>
          </div>
          <div class="step-wrapper">
            <div @click="jumpTo('selesai')" :class="$store.state.kplhStore.activeLanding == 'selesai'
              ? 'step-number-white'
              : 'step-number-red'
              ">
              7
            </div>
            <div class="step-hr-end"></div>
            <div class="step-name">Selesai</div>
          </div>
        </div>
        <div class="landing-form">
          <div class="landing-box">
            <!-- <router-view /> -->
            <keep-alive>
              <component :is="activeLanding" />
            </keep-alive>
          </div>
        </div>
      </div>
    </div>
    <div class="landing-footer-container">
      <span style="color:#fff; text-align:center">Copyright© 2022
        <span style="color:#fff; font-weight:bold">Sinarmas Mining</span>. All
        Rights reserved</span>
    </div>
    <GlobalLoading v-if="
      $store.state.modalStore.isGlobalLoading ||
      $store.state.level1.isLoading ||
      $store.state.kplhStore.globalLoading
    " />
    <Notif v-if="$store.state.showModalNotif" />
  </div>
</template>
<script>
import { api, api_lp } from '@/services/config'
import axios from 'axios'
export default {
  name: 'instruction',
  data() {
    return {
      pick: '',
      errorMessage: null,
    }
  },
  components: {
    GlobalLoading: () => import('@/components/V2/GlobalLoading.vue'),
    Notif: () => import('@/components/modal/Notification.vue'),
  },
  async created() {
    const request_id = this.$route.params.id

    this.setPage(request_id)
  },

  computed: {
    activeLanding: function () {
      const tab = this.$store.state.kplhStore.activeLanding

      switch (tab) {
        case 'register':
          return () => import('@/views/KPLH-Assessor/register.vue')
          break
        case 'profile':
          return () => import('@/views/KPLH-Assessor/profile.vue')
          break
        case 'grupah':
          return () => import('@/views/KPLH-Assessor/grupAH.vue')
          break
        case 'grupi1':
          return () => import('@/views/KPLH-Assessor/grupi1.vue')
          break
        case 'grupi2':
          return () => import('@/views/KPLH-Assessor/grupi2.vue')
          break
        case 'grupjm':
          return () => import('@/views/KPLH-Assessor/grupJM.vue')
          break
        case 'selesai':
          return () => import('@/views/KPLH-Assessor/selesai.vue')
          break
        default:
          break
      }
    },
  },
  methods: {
    async jumpTo(name) {
      const {
        register_step,
        profile_step,
        grupah_step,
        grupi1_step,
        grupi2_step,
        grupjm_step,
        end_step,
      } = this.$store.state.kplhStore

      if (name == 'register') {
        if (register_step) {
          this.$store.commit('kplhStore/SET_ACTIVE_PAGE', { name: 'register' })
        } else {
          this.sendNotif()
        }
      }

      if (name == 'profile') {
        if (profile_step) {
          this.$store.commit('kplhStore/SET_ACTIVE_PAGE', { name: 'profile' })
        } else {
          this.sendNotif()
        }
      }

      if (name == 'grupah') {
        if (grupah_step) {
          this.$store.commit('kplhStore/SET_ACTIVE_PAGE', {
            name: 'grupah',
          })
        } else {
          this.sendNotif()
        }
      }
      if (name == 'grupi1') {
        if (grupi1_step) {
          this.$store.commit('kplhStore/SET_ACTIVE_PAGE', { name: 'grupi1' })
        } else {
          this.sendNotif()
        }
      }
      if (name == 'grupi2') {
        if (grupi2_step) {
          this.$store.commit('kplhStore/SET_ACTIVE_PAGE', { name: 'grupi2' })
        } else {
          this.sendNotif()
        }
      }
      if (name == 'grupjm') {
        if (grupjm_step) {
          this.$store.commit('kplhStore/SET_ACTIVE_PAGE', { name: 'grupjm' })
        } else {
          this.sendNotif()
        }
      }
      if (name == 'selesai' && end_step) {
        if (end_step) {
          const tingkatResiko = this.$tingkatResikoValue().toLowerCase()

          if (tingkatResiko == 'kritis')
            this.$store.commit('kplhStore/CAL_KRITIS')
          if (tingkatResiko == 'tinggi')
            this.$store.commit('kplhStore/CAL_TINGGI')
          if (tingkatResiko == 'sedang')
            this.$store.commit('kplhStore/CAL_SEDANG')
          if (tingkatResiko == 'rendah')
            this.$store.commit('kplhStore/CAL_RENDAH')

          await this.$store.commit('kplhStore/SET_ACTIVE_PAGE', {
            name: 'selesai',
          })
        } else {
          this.sendNotif()
        }
      }
    },
    sendNotif() {
      this.$store.commit(
        'SET_NOTIF',
        'Selesaikan Step Sebelumnya Terlebih Dahulu.'
      )
    },
    async setPage(id) {
      try {
        let url = `${api}/api/v1/request/session-id/${id}`

        let pendaftaran_id = null
        let bidang_usaha = ''
        let bidang_usaha_id = null
        let nama_vendor = ''
        let alamat = ''
        let type_pendaftaran_id = null
        let register_gems = null
        let register_bce = null
        let register_bkes = null
        let request_id = null
        let tujuan_pendaftaran_id = null
        let vendor_ref = null
        let is_vendor_done = false
        let is_hse_validation = false
        let is_preview = false
        let is_head_approved = false

        const { data } = await axios({
          method: 'GET',
          url,
        })


        let dataStore = data.data

        if (data && data.status == 'success') {
          pendaftaran_id = dataStore && dataStore.id
          bidang_usaha =
            dataStore && dataStore.bidang_usaha_id == 1 ? 'bu' : 'perorangan'
          bidang_usaha_id = dataStore && dataStore.bidang_usaha_id
          type_pendaftaran_id = dataStore && dataStore.type_pendaftaran_id
          register_gems = dataStore && dataStore.register_gems
          register_bce = dataStore && dataStore.register_bce
          register_bkes = dataStore && dataStore.register_bkes
          nama_vendor = dataStore && dataStore.nama_vendor
          alamat = dataStore && dataStore.alamat
          request_id = dataStore && dataStore.request_id
          vendor_ref =
            dataStore && dataStore.request && dataStore.request.vendor_ref

          is_vendor_done = true
          is_hse_validation = true
          is_head_approved = true
          is_preview = true
          tujuan_pendaftaran_id = this.$get(
            data,
            'data.request.tujuan_pendaftaran'
          )
          if (type_pendaftaran_id == 1) {
            this.$store.commit('kplhStore/SET_KPLH_FORM', {
              name: 'choosed_country',
              value: {
                id: 63,
                kode_negara: 'ID',
                negara: 'Indonesia',
                kode_telepon: '62',
                mata_uang: 'Rupiah ',
                kode_mata_uang: 'IDR',
                createdAt: '2021-12-07T07:15:27.000Z',
                updatedAt: '2021-12-07T07:15:27.000Z',
                deletedAt: null,
              },
            })
            this.$store.commit('kplhStore/SET_KPLH_FORM', {
              name: 'phone_code',
              value: '+62',
            })
            this.$store.commit('kplhStore/SET_KPLH_FORM', {
              name: 'kplh_pic_phone_code',
              value: '+62',
            })
          }

          await this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'request_id',
            value: request_id,
          })
          await this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'user_id',
            value: this.$route.params.user,
          })
          await this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'is_preview',
            value: is_preview,
          })
          await this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'is_vendor_done',
            value: is_vendor_done,
          })
          await this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'is_head_approved',
            value: is_head_approved,
          })
          await this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'is_hse_validation',
            value: is_hse_validation,
          })
          await this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'vendor_ref',
            value: vendor_ref,
          })
          await this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'pendaftaran_id',
            value: pendaftaran_id,
          })
          await this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'tujuan_pendaftaran_id',
            value: tujuan_pendaftaran_id,
          })
          await this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'bidang_usaha_id',
            value: bidang_usaha_id,
          })
          await this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'type_pendaftaran_id',
            value: type_pendaftaran_id,
          })
          await this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'vendor_name',
            value: nama_vendor,
          })
          await this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'vendor_address',
            value: alamat,
          })
          await this.getInformasi(vendor_ref)
          await this.getKPLH(request_id)
          await this.getKplhPenilaian(request_id)
          await this.getKplhDoc(request_id)
          await this.getKBUG(request_id)
        }
      } catch (error) {
        await this.$store.commit(
          'SET_NOTIF',
          this.$get(error, 'response.data.message', 'Error')
        )
        // await this.$router.push('/')
      }
    },
    async getInformasi(vendor_id) {
      const url = `${api}/api/v1/d-vendor-informasi?id=${vendor_id}`

      await this.$store.commit('kplhStore/SET_KPLH_FORM', {
        name: 'globalLoading',
        value: true,
      })
      await axios({
        method: 'GET',
        url,
      })
        .then(async ({ data }) => {
          let informasi = data.data
          this.$store.commit('kplhStore/UPDATE_INFORMASI', informasi)
        })
        .catch(error => {
          // do nothing
          this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'globalLoading',
            value: false,
          })
        })
    },
    async getKBUG(id) {
      const url = `${api_lp}/api/v1/vendor/kbug/${id}`

      await this.$store.commit('kplhStore/SET_KPLH_FORM', {
        name: 'globalLoading',
        value: true,
      })

      await axios({
        method: 'GET',
        url,
      })
        .then(({ data }) => {
          let result = data.data
          this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'kbug_data',
            value: result,
          })
          this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'globalLoading',
            value: false,
          })
        })
        .catch(error => {
          // do nothing
          this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'globalLoading',
            value: false,
          })
        })
    },

    async getKPLH(id) {
      const url = `${api_lp}/api/v1/vendor/kplh-detail/${id}`

      await this.$store.commit('kplhStore/SET_KPLH_FORM', {
        name: 'globalLoading',
        value: true,
      })

      await axios({
        method: 'GET',
        url,
      })
        .then(({ data }) => {
          let result = data.data
          this.$store.commit('kplhStore/SET_KPLH_DETAIL', result)
          this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'globalLoading',
            value: false,
          })
        })
        .catch(error => {
          // do nothing
          this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'globalLoading',
            value: false,
          })
        })
    },
    async getKplhPenilaian(id) {
      const url = `${api_lp}/api/v1/vendor/kplh-penilaian/${id}`

      await this.$store.commit('kplhStore/SET_KPLH_FORM', {
        name: 'globalLoading',
        value: true,
      })

      await axios({
        method: 'GET',
        url,
      })
        .then(({ data }) => {
          let result = data.data
          this.$store.commit('kplhStore/SET_UPDATE_PENILAIAN', result)
          this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'globalLoading',
            value: false,
          })
        })
        .catch(error => {
          // do nothing
          this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'globalLoading',
            value: false,
          })
        })
    },
    async getKplhDoc(id) {
      const url = `${api_lp}/api/v1/vendor/kplh-doc/${id}`

      await this.$store.commit('kplhStore/SET_KPLH_FORM', {
        name: 'globalLoading',
        value: true,
      })

      await axios({
        method: 'GET',
        url,
      })
        .then(({ data }) => {

          let result = data.data
          this.$store.commit('kplhStore/SET_DOCUMENT_LIST', result)
          this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'globalLoading',
            value: false,
          })
        })
        .catch(error => {
          // do nothing
          this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'globalLoading',
            value: false,
          })
        })
    },
  },
}
</script>
